const faqs = [
  {
    q: '午马影院的剧集资源从哪里来？',
    a: '午马影院聚合全网优质电视剧资源，涵盖国产剧、韩剧、美剧、日剧等多元类型，所有剧集均来自正规版权合作与开放资源平台，确保高清流畅的观看体验。',
  },
  {
    q: '观看需要注册或付费吗？',
    a: '不需要。午马影院所有电视剧均支持免费在线观看，无需注册账号，无需支付任何费用，打开网站即可畅享高清追剧体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '午马影院全面适配桌面电脑、平板和手机端，无论使用 Chrome、Safari 还是 Edge 浏览器均可流畅播放，画质自适应网络环境，确保不缓冲。',
  },
  {
    q: '剧集更新速度快吗？',
    a: '我们与播出平台保持同步更新，热门剧集上线后最快30分钟内即可在午马影院观看。每日更新动态栏目实时同步最新上线信息，让你追剧不等待。',
  },
  {
    q: '画面清晰度怎么样？',
    a: '午马影院所有剧集默认提供1080P高清画质，部分热门剧集支持4K超清播放。采用智能自适应码率技术，确保在不同网络环境下都能获得流畅的观影体验。',
  },
  {
    q: '如果遇到播放问题怎么办？',
    a: '如遇播放卡顿或加载失败，可尝试刷新页面或切换播放线路。午马影院为每部剧集配备多条备用线路，确保观看不中断。也可通过页面底部联系方式向我们反馈。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于午马影院的使用问题，这里有你想要的答案
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group border border-background-200 rounded-xl overflow-hidden bg-background-50"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none hover:bg-background-100 transition-colors">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}